export default __webpack_public_path__ + "static/present-b1224b4e8f6e0c69871975eced41f85c.png";